export default __webpack_public_path__ + "static/media/alert-circle.2d393f86.svg";